﻿import { LanguageSelector } from '../';
export class MainNavigation {
    /**
     * Creates a new instance of the MainNavigation Class
     * @param {HTMLElement} element MainNavigation DOM Element
     */
    constructor(element) {
        this.element = element;

        this._refs = {
            el: element,
            body: document.querySelector('body'),
            header: document.querySelector('#header'),
            languageSelector: element.querySelector('.language-selector'),
            mainList: element.querySelector('.main-navigation__main-list'),
            ctaList: element.querySelector('.main-navigation__cta-list'),
            navItems: Array.from(element.querySelectorAll('.main-navigation__item > a')),
            subNavItems: Array.from(element.querySelectorAll('.main-navigation__menu__sub-item a')),
            toggl: element.querySelector('.main-navigation__main-menu-toggler')
        };

        this._props = {
            visible: false,
        }

        // Top notice-handling
        const oTopnotice = this._refs.header.querySelector('.top-notice');
        if(oTopnotice !== null) {
            this._refs.header.classList.add('header-top-notice');
        }

        // Language selector
        if(this._refs.languageSelector !== null) {
            this.lang = new LanguageSelector(this._refs.languageSelector);
        }

        // Event handlings
        this._refs.navItems.forEach(item => {
            // WCAG
            item.addEventListener('keydown', this._onMainNavigationItemKeyDown.bind(this));

            ["click", "keydown"].forEach((event) =>
              item.addEventListener(event, () =>
                localStorage.removeItem("scrollposition")
              )
            );

            // Caret bindings
            const oCaret = item.parentElement.querySelector('.main-navigation__caret');
            if(oCaret !== null) {
                oCaret.addEventListener('click', this._onMainNavigationItemCaretClick.bind(this));
            }
        });

        this._refs.subNavItems.forEach(item => item.addEventListener('keydown', this._onSubNavigationItemKeyDown.bind(this)));

        if(this._refs.toggl !== null) {
            this._refs.toggl.addEventListener('click', this._onTogglClick.bind(this));
        }
    }

    /**
     * Handler for WCAG implementation on sub-navigational items
     * @param {Event} e - Event interface
     */
    _onSubNavigationItemKeyDown (e = Event) {
        const
            oTarget = e.target,
            oMainMenuItem = oTarget.closest('.main-navigation__item'),
            oMainMenuItemLink = oMainMenuItem.children[0];

        switch(e.keyCode) {
            case 27: // ESC
                oMainMenuItem.classList.remove('is-current-page');
                oMainMenuItemLink.setAttribute('aria-expanded', 'false');

                this._refs.subNavItems.forEach(item => item.setAttribute('tabindex', '-1'))

                oMainMenuItemLink.focus();
            break;
        }
    }

    /**
     * Handler for WCAG implementation on main navigational items
     * @param {Event} e - Event Interface
     */
    _onMainNavigationItemKeyDown (e = Event) {
        const
            // Classes
            strItemActiveClass = 'is-current-page',
            // Elements
            oTarget = e.target,
            oParent = oTarget.parentElement,
            oSubmenuItems = Array.from(oParent.querySelectorAll('.main-navigation__menu__sub-item a')),
            // States
            isToggled = oParent.classList.contains(strItemActiveClass);

        switch(e.keyCode) {
            case 32: // Space
                // Element has a submenu
                e.preventDefault();

                // if item has no sub menu, go to page instead
                if(!oSubmenuItems.length) {
                    window.location.href = oTarget.getAttribute('href');
                    return true;
                }

                // Reset states
                this._refs.navItems.forEach(x => x.parentElement.classList.remove(strItemActiveClass));

                // Toggle active state
                if(isToggled) {
                    oTarget.parentElement.classList.remove(strItemActiveClass);
                    oTarget.setAttribute('aria-expanded', 'false');
                    oSubmenuItems.forEach(x => {
                        x.setAttribute('tabindex', '-1');
                    });
                } else {
                    oTarget.parentElement.classList.add(strItemActiveClass);
                    oTarget.setAttribute('aria-expanded', 'true');

                    // Set children as tabbable
                    oSubmenuItems.forEach((x, i) => {
                        if(i === 0) {
                            x.focus();
                        }

                        x.setAttribute('tabindex', '0');
                    });
                }
            break;
        }
    }

    /**
     * Handler for toggling menus on mobile devices
     * @param {Event} e - Event Interface
     */
    _onMainNavigationItemCaretClick (e = Event) {
        const
            oElement = e.target,
            oMainElement = oElement.parentElement,
            // Classnames
            strClassMenuIsExposed = 'secondary-level-is-expanded',
            strClassCurrentPage = 'is-current-page';

        if (oMainElement.classList.contains(strClassMenuIsExposed)) {
            oMainElement.classList.remove(strClassMenuIsExposed);
            oMainElement.classList.remove(strClassCurrentPage);
        } else {
            this._refs.navItems.forEach(item => {
                item.parentElement.classList.remove(strClassMenuIsExposed);
                item.parentElement.classList.remove(strClassCurrentPage);
            });
            oMainElement.classList.add(strClassMenuIsExposed);
        }
    }

    /**
     * Handler for helping toggling between visible/non-visible on mobile devices
     */
    _onTogglClick () {
        const
            strMenuClassVisibility = 'main-list-is-visible',
            strBodyClassMenuVisibility = 'main-navigation-is-visible';

        if(this._props.visible) {
            this._refs.body.classList.remove(strBodyClassMenuVisibility);
            this._refs.el.classList.remove(strMenuClassVisibility);
        } else {
            this._refs.body.classList.add(strBodyClassMenuVisibility);
            this._refs.el.classList.add(strMenuClassVisibility);
        }

        this._props.visible = !this._props.visible;
    }
}